import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class FreeDataCriteria extends BasicCriteria {
dataType: string;
freeDataCodeList: string[];
validityDate: number | null;
}

